import { render, staticRenderFns } from "./createRequirement.vue?vue&type=template&id=eee21ec8&"
import script from "./createRequirement.vue?vue&type=script&lang=ts&"
export * from "./createRequirement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports